/**
 * Die Einstiegsdatei der React-Anwendung.
 * StrictMode wurde entfernt, um Kompatibilitätsprobleme mit react-beautiful-dnd zu beheben.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import TodoListApp from './TodoListApp'; 

// Erstellt den React-Root-Container im DOM-Element mit der ID 'root'
const root = ReactDOM.createRoot(document.getElementById('root'));
// Rendert die Anwendung
root.render(<TodoListApp />);

//(
  // StrictMode hilft, Probleme in der Anwendung zu erkennen
  //<React.StrictMode>
 //   {/* Die Hauptkomponente wird hier gerendert */}
   // <TodoListApp /> 
 // </React.StrictMode>
//);

// Rendert die Anwendung OHNE StrictMode, damit Drag & Drop funktioniert
root.render(
    <TodoListApp /> 
);